import "css/shippingResponsive.css";
import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import PropTypes from 'prop-types';
import TableSortingShippingStore from 'pages/shipping/editOrNewShipping/SortingTablesShippingStore';
const initialFiltersStore = {
  "idFrom": "",
  "idTo": "",
  "documentIdFrom": "",
  "documentIdTo": "",
  "tradenameFrom": "",
  "tradenameTo": "",
  "vehicleStoreFrom": "",
  "vehicleStoreTo": ""
};
const initialStateStore = [{
  "rel_trans_store_id": "",
  "rel_trans_documentid": "",
  "rel_trans_tradename": "",
  "colorhex": ""
}];
const ShippingSearchStores = ({
  showModalSearchStores,
  setShowModalSearchStores,
  selectStores,
  setFormShipping
}) => {
  const LIMITPAGESIZE = useSelector(state => state.loginUser.defaultticketsformat.limitpagesize);
  const {
    t,
    i18n
  } = useTranslation(['listDataShipping']);
  const state = useSelector(state => state);
  const {
    token
  } = state.loginUser;
  const [dataStore, setDataStore] = useState(initialStateStore);
  const [isLoadingErrorStore, setIsLoadingErrorStore] = useState(false);
  const isLoadingData = useSelector(state => state.loading.isLoading);
  const [inputTextStore, setInputTextStore] = useState("");
  const [applyFiltersStore, setApplyFiltersStore] = useState(initialFiltersStore);
  const [filtersStore, setFiltersStore] = useState(initialFiltersStore);
  const [openEditFilterStore, setOpenEditFilterStore] = useState(false);
  const [errorsFiltersStore, setErrorsFiltersStore] = useState({});
  const [numTotRegFilter, setNumTotRegFilter] = useState(0);
  const [numTotRegStore, setNumTotRegStore] = useState(0);
  const [activeOffsetStore, setActiveOffsetStore] = useState(false);
  const [currencyOffsetStore, setCurrencyOffsetStore] = useState(0);
  const [rangeOffsetStore, setRangeOffsetStore] = useState([{}]);
  const dispatch = useDispatch();
  const keyPress = useCallback(e => {
    if (e.key === 'Escape' && setShowModalSearchStores) {
      setDataStore(initialStateStore);
      setIsLoadingErrorStore(false);
      dispatch(setLoading(false));
      setInputTextStore("");
      setApplyFiltersStore(initialFiltersStore);
      setFiltersStore(initialFiltersStore);
      setOpenEditFilterStore(false);
      setErrorsFiltersStore({});
      setNumTotRegFilter(0);
      setNumTotRegStore(0);
      setActiveOffsetStore(false);
      setCurrencyOffsetStore(0);
      setRangeOffsetStore([{}]);
      setShowModalSearchStores(false);
    }
  }, [setDataStore, setIsLoadingErrorStore, setInputTextStore, setApplyFiltersStore, setFiltersStore, setOpenEditFilterStore, setErrorsFiltersStore, setNumTotRegFilter, setNumTotRegStore, setActiveOffsetStore, setCurrencyOffsetStore, setRangeOffsetStore, dispatch, setShowModalSearchStores]);
  const handleCloseDataEditStore = () => {
    setDataStore(initialStateStore);
    setIsLoadingErrorStore(false);
    dispatch(setLoading(false));
    setInputTextStore("");
    setApplyFiltersStore(initialFiltersStore);
    setFiltersStore(initialFiltersStore);
    setOpenEditFilterStore(false);
    setErrorsFiltersStore({});
    setNumTotRegFilter(0);
    setNumTotRegStore(0);
    setActiveOffsetStore(false);
    setCurrencyOffsetStore(0);
    setRangeOffsetStore([{}]);
    setShowModalSearchStores(false);
  };
  const toggleDrawerSearchFormStores = open => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditStore();
    }
  };
  let inputHandlerStore = e => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextStore(lowerCase);
  };
  const openEditFiltersStore = () => {
    setFiltersStore(applyFiltersStore);
    setOpenEditFilterStore(!openEditFilterStore);
  };
  const toggleDrawerFilterEditStore = open => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditStore();
    }
  };
  const handleCancelFiltersStore = () => {
    setErrorsFiltersStore({});
    setFiltersStore(initialFiltersStore);
    setOpenEditFilterStore(!openEditFilterStore);
  };
  const handleChangeFilterEditStore = e => {
    const {
      name,
      value
    } = e.target;
    setFiltersStore(filtersStore => ({
      ...filtersStore,
      [name]: value
    }));
  };
  const handleBlurFilterEditStore = e => {
    setErrorsFiltersStore(validateFormFilterStore());
    handleChangeFilterEditStore(e);
  };
  const handleSubmitFilterEditStore = () => {
    setErrorsFiltersStore(validateFormFilterStore());
    if (Object.keys(errorsFiltersStore).length === 0) {
      setApplyFiltersStore(filtersStore);
      setFiltersStore(initialFiltersStore);
      setErrorsFiltersStore({});
      setOpenEditFilterStore(false);
    } else {
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  };
  const handleDeleteFiltersStore = () => {
    setErrorsFiltersStore({});
    setFiltersStore(initialFiltersStore);
    setApplyFiltersStore(initialFiltersStore);
    setOpenEditFilterStore(!openEditFilterStore);
  };
  const validateFormFilterStore = () => {
    let errorsFiltersStore = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    if (filtersStore.idFrom !== "" & !regexNumber.test(filtersStore.idFrom)) {
      errorsFiltersStore.idFrom = 'Text_TextNoNumber';
    }
    if (filtersStore.idTo !== "" & !regexNumber.test(filtersStore.idTo)) {
      errorsFiltersStore.idTo = 'Text_TextNoNumber';
    }
    if (filtersStore.idFrom !== "" & !errorsFiltersStore.idFrom !== undefined) {
      if (filtersStore.idTo !== "" & !errorsFiltersStore.idTo !== undefined) {
        if (parseInt(filtersStore.idTo) < parseInt(filtersStore.idFrom)) {
          errorsFiltersStore.idTo = 'Text_TextGreater_Id';
        }
      }
    }
    if (regexInvalidCharacters.test(filtersStore.documentIdFrom)) {
      errorsFiltersStore.documentIdFrom = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(filtersStore.documentIdTo)) {
      errorsFiltersStore.documentIdTo = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(filtersStore.tradenameFrom)) {
      errorsFiltersStore.tradenameFrom = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(filtersStore.tradenameTo)) {
      errorsFiltersStore.tradenameTo = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(filtersStore.vehicleStoreFrom)) {
      errorsFiltersStore.vehicleStoreFrom = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(filtersStore.vehicleStoreTo)) {
      errorsFiltersStore.vehicleStoreTo = 'Text_TextNoValid';
    }
    if (filtersStore.documentIdTo !== "" & filtersStore.documentIdTo < filtersStore.documentIdFrom) {
      errorsFiltersStore.documentIdTo = 'Text_TextGreater_documentid';
    }
    if (filtersStore.tradenameTo !== "" & filtersStore.tradenameTo < filtersStore.tradenameFrom) {
      errorsFiltersStore.tradenameTo = 'Text_TextGreater_tradename';
    }
    if (filtersStore.vehicleStoreTo !== "" & filtersStore.vehicleStoreTo < filtersStore.vehicleStoreFrom) {
      errorsFiltersStore.vehicleStoreTo = 'Text_TextGreater_vehicles';
    }
    return errorsFiltersStore;
  };
  const filteredDataStore = dataStore.filter(el => {
    if (inputTextStore === '') {
      return el;
    } else {
      let dataTranslate = String(el.rel_trans_store_id || '') + String(el.rel_trans_documentid || '') + String(el.rel_trans_tradename || '') + +(el.vehicles !== undefined && el.vehicles !== null && el.vehicles.length > 0 ? el.vehicles.map(current => {
        return current.licenseplate;
      }) : "");
      let result = dataTranslate.toLowerCase().includes(inputTextStore.toLowerCase());
      return result;
    }
  });
  useEffect(() => {
    const handleKeyPress = event => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
  useEffect(() => {
    let isMounted = true;
    const fetchnumTotRegStore = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `shipping/getinformationtablestore`, token);
        if (getData.err) {
          setDataStore(initialStateStore);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegStore(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    };
    const fetchnumTotRegFilter = async () => {
      try {
        const getData = await helpHttp().post(ENDPOINT, `shipping/getcountfilterstore`, token, applyFiltersStore);
        if (getData.err || getData.message === "Load failed") {
          setDataStore(initialStateStore);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    };
    const fetchDataStore = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get3(ENDPOINT, `shipping/getstores`, token, currencyOffsetStore, LIMITPAGESIZE, applyFiltersStore);
        if (getData.err || getData.message === "Load failed") {
          setDataStore(initialStateStore);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataStore(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    };
    if (showModalSearchStores) {
      fetchnumTotRegStore();
      fetchnumTotRegFilter();
      fetchDataStore();
    }
    return () => {
      isMounted = false;
    };
  }, [t, i18n, token, dispatch, applyFiltersStore, currencyOffsetStore, showModalSearchStores, LIMITPAGESIZE]);
  return <>
      {showModalSearchStores && <div>
          <SwipeableDrawer PaperProps={{
        className: "shipping-search-panel shipping-lookup-panel"
      }} anchor='right' open={true} onClose={toggleDrawerSearchFormStores(false)} onOpen={toggleDrawerSearchFormStores(true)}>
            <Container maxWidth={false}>
              <Box sx={{
            bgcolor: '#ffffff',
            width: '100%',
            maxWidth: '100%'
          }}>
                <br />
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                    {isLoadingErrorStore ? <i className="fas fa-solid fa-exclamation fa-2x text-danger"></i> : isLoadingData ? <CircularProgress color={"primary"} /> : <i className="fas fa-address-card text-warning"></i>} {t('Text_TICKETS_Stores_Search')}
                  </h1>
                  <div>
                    <button type="button" className="formdi-pending-btn formdi-pending-btn--primary" onClick={handleCloseDataEditStore}>{t('Button_Back')}</button><> </>
                  </div> 
                </div>  
                <br /> 
                <div className="formdi-pending-search"> 
                  <TextField autoComplete="off" id="outlined-basic" variant="outlined" value={inputTextStore} inputProps={{
                style: {
                  fontSize: '18px'
                }
              }} InputLabelProps={{
                style: {
                  fontSize: '18px',
                  background: '#FFFFFF'
                }
              }} placeholder={t('Text_Store_Search')} onChange={inputHandlerStore} fullWidth label={t('Text_Store_Search')}>
                  </TextField>
                </div>
                <br />
                <div id="myNewDIV" className="formdi-pending-filters">
                  <h1 className="formdi-pending-filter-title">{t('Text_Filter')}</h1> 
                  <div className="formdi-pending-filters-row">
                    <button type="button" className={`formdi-pending-chip ${applyFiltersStore.documentIdFrom !== "" || applyFiltersStore.documentIdTo !== "" ? "formdi-pending-chip--active" : ""}`} onClick={openEditFiltersStore}>
                      <span className={`formdi-pending-dot ${applyFiltersStore.documentIdFrom !== "" || applyFiltersStore.documentIdTo !== "" ? "formdi-pending-dot--on" : ""}`} />
                      {t("Text_documentid")}
                    </button>
                    <button type="button" className={`formdi-pending-chip ${applyFiltersStore.tradenameFrom !== "" || applyFiltersStore.tradenameTo !== "" ? "formdi-pending-chip--active" : ""}`} onClick={openEditFiltersStore}>
                      <span className={`formdi-pending-dot ${applyFiltersStore.tradenameFrom !== "" || applyFiltersStore.tradenameTo !== "" ? "formdi-pending-dot--on" : ""}`} />
                      {t("Text_tradename")}
                    </button> 
                  </div>
                </div>  
                <br />
                {!isLoadingData ? <>
                    <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content"> 
                        <TableSortingShippingStore dataStore={filteredDataStore} numTotRegFilter={numTotRegFilter} titleTable={t('Text_Stores_Table')} numTotRegStore={numTotRegStore} activeOffsetStore={activeOffsetStore} rangeOffsetStore={rangeOffsetStore} currencyOffsetStore={currencyOffsetStore} setCurrencyOffsetStore={setCurrencyOffsetStore} selectStores={selectStores} setFormShipping={setFormShipping} handleCloseDataEditStore={handleCloseDataEditStore}>
                        </TableSortingShippingStore>
                      </div>             
                    </div>
                    {openEditFilterStore && <div>
                      <SwipeableDrawer PaperProps={{
                  className: "shipping-search-panel shipping-lookup-panel"
                }} anchor='right' open={true} onClose={toggleDrawerFilterEditStore(false)} onOpen={toggleDrawerFilterEditStore(true)}>
                        <Container maxWidth={false}>
                          <Box sx={{
                      bgcolor: '#ffffff',
                      minHeight: '100vh',
                      width: '100%',
                      maxWidth: '100%'
                    }}>
                            <br />
                              <div id="myDIV">
                                <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                              </div>
                              <hr className="sidebar-divider d-none d-md-block" />
                              <form autoComplete="off" className="shipping-search-filters newfilterformstore" onSubmit={handleCancelFiltersStore}>  
                                <div className="form-floating mb-3 px-4 primary">
                                  <div className="form-group">
                                    <TextField autoComplete="off" id="documentIdFrom" name="documentIdFrom" value={filtersStore.documentIdFrom} inputProps={{
                              style: {
                                width: 350,
                                fontSize: '18px'
                              },
                              maxLength: 100
                            }} InputLabelProps={{
                              style: {
                                fontSize: '18px',
                                background: '#FFFFFF'
                              }
                            }} label={errorsFiltersStore.documentIdFrom != null ? t(errorsFiltersStore.documentIdFrom) : t('Text_Filter_documentId_From')} placeholder={t('PlaceHolder_Filter_documentid_From')} variant="outlined" onBlur={handleBlurFilterEditStore} onChange={handleChangeFilterEditStore} />
                                    
                                    <TextField autoComplete="off" id="documentIdTo" name="documentIdTo" value={filtersStore.documentIdTo} inputProps={{
                              style: {
                                width: 350,
                                fontSize: '18px'
                              },
                              maxLength: 100
                            }} InputLabelProps={{
                              style: {
                                fontSize: '18px',
                                background: '#FFFFFF'
                              }
                            }} label={errorsFiltersStore.documentIdTo != null ? t(errorsFiltersStore.documentIdTo) : t('Text_Filter_documentId_To')} placeholder={t('PlaceHolder_Filter_documentid_to')} variant="outlined" onBlur={handleBlurFilterEditStore} onChange={handleChangeFilterEditStore} />
                                  </div>
                                  <div className="form-group">
                                    <TextField autoComplete="off" id="tradenameFrom" name="tradenameFrom" value={filtersStore.tradenameFrom} inputProps={{
                              style: {
                                width: 350,
                                fontSize: '18px'
                              },
                              maxLength: 100
                            }} InputLabelProps={{
                              style: {
                                fontSize: '18px',
                                background: '#FFFFFF'
                              }
                            }} label={errorsFiltersStore.tradenameFrom != null ? t(errorsFiltersStore.tradenameFrom) : t('Text_Filter_tradename_From')} placeholder={t('PlaceHolder_Filter_tradename_From')} variant="outlined" onBlur={handleBlurFilterEditStore} onChange={handleChangeFilterEditStore} />
                                      
                                    <TextField autoComplete="off" id="tradenameTo" name="tradenameTo" value={filtersStore.tradenameTo} inputProps={{
                              style: {
                                width: 350,
                                fontSize: '18px'
                              },
                              maxLength: 100
                            }} InputLabelProps={{
                              style: {
                                fontSize: '18px',
                                background: '#FFFFFF'
                              }
                            }} label={errorsFiltersStore.tradenameTo != null ? t(errorsFiltersStore.tradenameTo) : t('Text_Filter_tradename_To')} placeholder={t('PlaceHolder_Filter_tradename_to')} variant="outlined" onBlur={handleBlurFilterEditStore} onChange={handleChangeFilterEditStore} />
                                  </div> 
                                </div>
                                 <hr className="sidebar-divider d-none d-md-block" />
                                <div className="formdi-pending-action-group">
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button" onClick={handleSubmitFilterEditStore}>
                                    {t('Button_Apply')}
                                  </button> 
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersStore}>
                                    {t('Button_Cancel_Filters')}
                                  </button>
                                </div>
                            </form>
                          </Box>
                        </Container>
                      </SwipeableDrawer>
                    </div>}  
                  
                  {/* End Content Row */}
                  </> : <LoadingNews />}            
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>}  
    </>;
};
ShippingSearchStores.propTypes = {
  showModalSearchStores: PropTypes.bool.isRequired,
  setShowModalSearchStores: PropTypes.func.isRequired,
  selectStores: PropTypes.string.isRequired,
  setFormShipping: PropTypes.func.isRequired
};
export default ShippingSearchStores;